import { quoteLiteral } from '@w/db-custom/names'

/** workspace.list memberships, enriched from the existing auth profile. */
export type PersonMember = { userId: string; email: string | null; name?: string | null; avatar?: string | null }

export function personName(member: PersonMember): string {
  return member.name ?? member.email ?? member.userId
}

/** User ids use @w/utils' 19-character ULID alphabet (id/ulid.ts:18-21),
 * as in auth.users and pagePermissions.principalId.
 * Membership cannot be a CHECK: departed members' assignments must survive.
 */
export function personCheck(column: string): string {
  return `length(${column}) = 19 AND ${column} NOT GLOB '*[^0-9A-Za-z_]*'`
}

export function isPersonDefinition(definition: string): boolean {
  return definition.includes("NOT GLOB '*[^0-9A-Za-z_]*'") && /\blength\s*\([^)]*\)\s*=\s*19\b/iu.test(definition)
}

/** CASE uses the current member snapshot without subqueries in ALTER USING. */
export function personText(column: string, members: readonly PersonMember[]): string {
  const cases = members.map(member => `WHEN ${quoteLiteral(member.userId)} THEN ${quoteLiteral(personName(member))}`).join(' ')
  return `CASE WHEN ${column} IS NULL THEN NULL ELSE ${cases ? `CASE ${column} ${cases} ELSE 'Former member' END` : "'Former member'"} END`
}

export function textPerson(text: string, members: readonly PersonMember[]): string {
  const cases = members.toSorted((a, b) => a.userId < b.userId ? -1 : a.userId > b.userId ? 1 : 0).map(member => {
    const matches = [member.name, member.email].filter((value): value is string => value !== null && value !== undefined)
    return matches.length > 0 ? `WHEN ${matches.map(value => `${text} = ${quoteLiteral(value)} COLLATE BINARY`).join(' OR ')} THEN ${quoteLiteral(member.userId)}` : ''
  }).filter(Boolean).join(' ')
  return cases ? `CASE ${cases} ELSE NULL END` : 'NULL'
}
